import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, MessageCircleIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF Digital'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="sb1chsl5257m">
      <div className="mx-auto max-w-4xl px-5 text-center sm:pt-16 pt-[35px] pb-[5px]" data-id="element-84" data-mp="sde28rx51jv8">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-extrabold uppercase tracking-[0.25em] text-gold mt-[-25px] mb-[-25px] text-[12px]" data-id="element-85" data-mp="nbygsyr1tbcb">
          🏆 SIGMA SMART™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="tracking-tight sm:text-6xl pb-[33px] font-[800] text-center font-display pt-[34px] text-[22px] text-[#7CB0FF]" data-id="element-86" data-mp="3j6fw9kdl53b7">
          Pasá del chat a la cita
          <br data-id="element-87" data-mp="3ebisarv5xk56" />
          <span className="text-[20px] text-[#7CB0FF]" data-id="element-88" data-mp="30i18d5yke5em">sin rogar ni improvisar</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md pb-[19px] mt-[-10px] mb-[-10px]" data-id="element-89" data-mp="358rdqj6zq89b">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-azul/25 blur-3xl" data-id="element-90" data-mp="2vgu25bc2lea2" />
          <img src="https://cdn.magicpatterns.com/uploads/daXLtc99WM9KMCxrau47k3/ChatGPT_Image_27_jul_2026,_21_39_08.png" alt="Protocolo 3C — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto max-w-[360px] w-[260px] h-[260px]" data-id="element-91" data-mp="2lkqxnytqx3jy" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mx-auto max-w-2xl font-bold text-azul-soft sm:text-xl text-[16px] mt-[-2px] mb-[-2px]" data-id="element-92" data-mp="na060pwkyn9y">
          PROTOCOLO 3C: Chatear, Conectar, Concretar
          <br data-id="element-93" data-mp="1ayjgnc33rc57" />
          <span className="text-white/80" data-id="element-94" data-mp="1622irq63pjex">Decile adiós al visto en tus mensajes</span>
        </motion.h2>

        <div className="mt-9" data-id="element-95" data-mp="112g89ohnqh9t">
          <CTAButton data-id="element-96" data-mp="111es55lsb4l8">Quiero aplicar el Protocolo 3C</CTAButton>
          <p className="mx-auto mt-4 max-w-2xl text-white/70 sm:text-lg text-[14px] pt-[15px]" data-id="element-97" data-mp="x1edbjurwrdn">
            Un sistema simple y concreto para chatear con intención, generar conexión real y cerrar
            la cita con confianza. Sin quedar en visto. Sin hilos eternos. Sin excusas de ella.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" data-id="element-98" data-mp="1x9umefegzlpj">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-99" data-mp="21b631vfd8wll">
                <Icon className="h-3.5 w-3.5 text-azul-soft" data-id="element-100" data-mp="2b1hiae4i2s7s" />
                {label}
              </span>)}
          </div>
          <p className="mt-4 text-sm font-semibold text-white/50 pt-[7px] pb-[6px]" data-id="element-101" data-mp="2fzj436tb95my">
            12 Tomos · 5 Bonos · 100+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50 mt-[10px] mb-[10px]" data-id="element-102" data-mp="2p1sabkhjqcuj">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="uo0to10suspl">
              <Icon className="h-4 w-4 text-gold" data-id="element-104" data-mp="zkrbotw5zydn" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold pt-[4px] pb-[4px] mt-[18px] mb-[18px]" data-id="element-105" data-mp="4acohj4ke1al">
          🔥 Oferta de lanzamiento — 80% OFF · Acceso inmediato
        </motion.div>
      </div>
    </header>;
}